import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import i18n from '../../../../../constants/initLng';
import { useTranslation } from "react-i18next";
import * as CPN from "antd";
import * as Func from "../../../../../helpers/functions";
import Modal from '../../../common/component/Modal';
import Dropdown from '../../../common/component/Dropdown';
import { PATHS } from '../../../../../constants/Define';

export const EditComponent = (props) => {

    const { t } = useTranslation();
    const removeBanner = () => {
        props.onDeleteBanner({ id: props.item.id })
    }
    const onRemove = () => {
        const { confirm } = Modal;
        confirm({
            title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.banner.title`)),
            content: props.item.name,
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeBanner,
        });
    };
    return (
        <Fragment>
            <Dropdown overlay={
                <CPN.Menu className="action-menu">
                    {
                        props.permisionActions && props.permisionActions.allowUpdate &&
                        <CPN.Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.BANNER.DETAIL.path, { id: props.item.id })} className={`mr-2`}>
                                <CPN.Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </CPN.Menu.Item>
                    }

                    {
                        props.permisionActions && props.permisionActions.allowDelete &&
                        <CPN.Menu.Item onClick={onRemove}><CPN.Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</CPN.Menu.Item>
                    }
                </CPN.Menu>
            }>
                <CPN.Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        </Fragment>
    )
};
